module.exports = {
  EnrichedPlayer: {
    Allow_fullscreen: "Allow fullscreen",
    Show_controls: "Show Controls",
    Replay: "Replay",
    Autoplay: "Autoplay",
    URL: "URL",
    Video: "Video",
    background_color: "Background color",
    border_color: "Border color",
    border_size: "Border Size",
    border_style: "Border Style",
    box_style: "Box style",
    opacity: "Opacity",
    padding: "Padding",
    pos: "Moment",
    PluginName: "Video Player",
    radius: "Radius",
    source: "Source",
    message_mark_error:
      "You've chosen an incorrect value. You must introduce a time like in the format of h:mm:ss or mm:ss. E.g. 1:33",
    AutoPlay: "Autoplay",
    Loop: "Loop",
    Sound: "Sound",
    DownloadStyled: "Download with style",
    DownloadStyledProgress: "Rendering… {{p}}%",
    DownloadStyledCancel: "Cancel",
    DownloadStyledFailed: "Download failed",
    DownloadWithSound: "Download with sound (click to mute)",
    DownloadMuted: "Download without sound (click to unmute)",
  },
};
